/* eslint-disable no-unused-vars */
import classNames from 'classnames';
import { useState } from 'react';
import request from '../../utils/APIHelper/request';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import { toast } from 'react-toastify';
import loadingGif from '../../assets/Other/loading.gif';

import Swal from 'sweetalert2';
import AgentAddingWindow from '../AddingAgent/AgentAddingWindow';
import { cleanObject } from '../../utils/cleanObject';

const UpdateAgentInList = ({ defaultAgentData, extensionData }) => {
  const [createLoading, setCreateLoading] = useState(false);

  const [data, setData] = useState(defaultAgentData);
  const [extension, setExtension] = useState(extensionData);

  const isExtensionUpdated = () => {
    console.log('extension', cleanObject(extension));
    console.log('extension data', cleanObject(extensionData));
    return (
      JSON.stringify(cleanObject(extension)) !==
      JSON.stringify(cleanObject(extensionData))
    );
  };

  const isAgentUpdated = () => {
    return JSON.stringify(defaultAgentData) !== JSON.stringify(data);
  };

  const isDataUpdated = () => {
    return isAgentUpdated() || isExtensionUpdated();
  };

  const createNewAgent = async () => {
    if (isDataUpdated()) {
      if (data?.agentCode) {
        const result = await request({
          url: `${controllers.agent}updateAnAgent`,
          type: requestTypes.post,
          params: { id: defaultAgentData.id },
          body: { agent: data, ext: cleanObject(extension) },
          setLoading: setCreateLoading,
        });
        if (result.code !== responseTypes.success) {
          toast.error(result.message);
        } else {
          toast.success(result.message);
          window.location.reload();
          Swal.close();
        }
      } else {
        toast.error('Agent Code is madatory field!');
      }
    }
  };

  return (
    <>
      <div>
        <div>
          <AgentAddingWindow
            data={data}
            setData={setData}
            extension={extension}
            setExtension={setExtension}
            enableExtension={data?.branchId === 2}
          />
        </div>
        <div className="p-4">
          <div
            className={classNames(
              'text-left text-sm my-1',
              !isDataUpdated() ? 'text-yellow-600' : 'opacity-0',
            )}
          >
            No changes to save
          </div>
          {createLoading ? (
            <img
              className="w-5 h-5 mx-auto float-left my-2 ml-3"
              src={loadingGif}
            />
          ) : (
            <div
              onClick={createNewAgent}
              className={classNames(
                'float-left bg-blue-900 text-white inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer',
                !isDataUpdated() && '!bg-gray-400 !cursor-auto',
              )}
            >
              Save
            </div>
          )}

          <div
            onClick={() => Swal.close()}
            className={classNames(
              'float-right bg-gray-300 text-gray-700 inline-block px-3 py-2 rounded-[0.2rem] cursor-pointer',
            )}
          >
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateAgentInList;
